/**
 * The department types sv_organization accepts (domain enum: department.rs). The app
 * offers exactly this set in the picker; `division` is the default for a plain org unit.
 * Labels resolve through i18n (`department.type.<value>`), never baked in here.
 */
export const DEPARTMENT_TYPES = [
  'division',
  'building',
  'floor',
  'room',
  'checkpoint',
  'gate',
  'class',
  'other',
] as const;

export type DepartmentType = (typeof DEPARTMENT_TYPES)[number];

export const DEFAULT_DEPARTMENT_TYPE: DepartmentType = 'division';

/**
 * Ключ подписи для типа отдела.
 *
 * Неизвестный тип сворачивается в `other`, а не собирается в ключ как есть.
 * `department_type` объявлен как `string`, а не как перечисление: сервер волен
 * завести новый тип, и в тот день собранный ключ напечатался бы человеку прямо
 * в карточку — «department.type.warehouse» вместо слова. Именно это и было видно
 * на отделе, у которого тип не пришёл вовсе.
 *
 * `other` — не заглушка, а честный ответ: приложение действительно не знает, что
 * это за тип, и «Другое» — ровно та корзина, которая для такого заведена.
 */
export function departmentTypeLabelKey(type: string): string {
  const known = (DEPARTMENT_TYPES as readonly string[]).includes(type);
  return `department.type.${known ? type : 'other'}`;
}
